export const batchSubmittedNotice = (count, saved) => ({
  open: true,
  message: saved
    ? `Submitted ${count} companies. Results will remain in Saved Search and company history.`
    : `Submitted ${count} companies for AI Enrichment`,
  severity: 'info',
});

const noLeadNote = (count) => (count
  ? ` ${count} ${count === 1 ? 'company' : 'companies'} had no verified lead.` : '');

// A no-verified-lead row is never counted as a success (FE #493).
export const batchCompletedNotice = (failedCount, saved, noLeadCount = 0) => {
  const failedText = `with ${failedCount} failed ${failedCount === 1 ? 'result' : 'results'}.`;
  let message = noLeadCount ? 'Batch AI Enrichment completed.' : 'Batch AI Enrichment completed successfully';
  if (saved) {
    message = failedCount || noLeadCount
      ? `Saved Search enrichment completed${failedCount ? ` ${failedText}` : '.'}`
      : 'Saved Search enrichment completed. Results remain in Saved Search and company history.';
  }
  return {open: true, message: message + noLeadNote(noLeadCount),
    severity: failedCount || noLeadCount ? 'warning' : 'success'};
};

export const ACTIVE_BATCH_MESSAGE =
  'Another AI enrichment is still running for your account. Wait for it to finish, then try again.';

const isStaleQuote = (status, saved, responseBody) =>
  status === 409 && saved && Boolean(responseBody?.detail?.error_code?.startsWith('QUOTE_'));

export const batchSubmissionErrorNotice = (status, message, saved, responseBody) => {
  const requote = isStaleQuote(status, saved, responseBody);
  let text = message;
  if (status === 402) text = 'Out of credits.';
  else if (requote) text = 'The quote expired or changed. Review the new quote before charging.';
  else if (!status) text = 'Could not start AI enrichment. Check company history before retrying.';
  else if (status === 409 && responseBody && !responseBody.detail && !responseBody.message) text = ACTIVE_BATCH_MESSAGE;
  return {
    open: true,
    message: text,
    severity: status === 402 || (status === 409 && saved) ? 'warning' : 'error',
    persist: true,
    ...(status === 402 && message !== text ? {detail: message} : {}),
    ...(requote ? {requote} : {}),
  };
};
